import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import i18n from "../../../../../constants/i18n";
import {
  COUNTRIES,
  KHATTABAT_MATCHING_FIELD_SIZE
} from "../../../../../constants/user-profile";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";
import CitySearch from "./CitySearch";
import ExcludeSearch from "./ExcludeSearch";
import FilterMultiSelect from "./FilterMultiSelect";

const KhattabatMatchingLocationFilters = withLiteObserverAndTheme(() => {
  return (
    <>
      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Stack sx={{ flex: 1, minWidth: 0 }}>
            <FilterMultiSelect
              label={i18n.get("NATIONALITY")}
              options={COUNTRIES()}
              value={getKhattabatMatchingStore().matchNationalityFilter.get()}
              onChange={getKhattabatMatchingStore().setMatchNationalityFilter}
            />
          </Stack>
          <ExcludeSearch
            onClick={
              getKhattabatMatchingStore().toggleIsChosenNationalitiesExcluded
            }
            state={getKhattabatMatchingStore().isChosenNationalitiesExcluded.get()}
            isDisabled={getKhattabatMatchingStore().isNationalitiesExcludingDisabled.get()}
          />
        </Stack>
      </Grid>

      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Stack sx={{ flex: 1, minWidth: 0 }}>
            <FilterMultiSelect
              label={i18n.get("COUNTRY_OF_RESIDENCE")}
              options={COUNTRIES()}
              value={getKhattabatMatchingStore().matchResidenceFilter.get()}
              onChange={getKhattabatMatchingStore().setMatchResidenceFilter}
            />
          </Stack>
          <ExcludeSearch
            onClick={
              getKhattabatMatchingStore()
                .toggleIsChosenResidenceCountriesExcluded
            }
            state={getKhattabatMatchingStore().isChosenResidenceCountriesExcluded.get()}
            isDisabled={getKhattabatMatchingStore().isResidenceExcludingDisabled.get()}
          />
        </Stack>
      </Grid>

      <CitySearch />
    </>
  );
});

export default KhattabatMatchingLocationFilters;
